<template>
<div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div style="max-width:1420px" class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Add Trade</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <h3>Selected Trades </h3>
                <table style="margin-bottom: 60px;" class="table align-items-center table-flush table-hover bidtbl">
                      <thead class="thead-light psticky">
                      <tr>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >ACCOUNT <br> NO</th>
                          <th
                            scope="col" 
                            class="sort text-center"
                            >BUY/SELL </th> 
                            <th 
                              scope="col" 
                              class="sort text-center"
                              >TRADE <br> DATE</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >SETTLEMENT <br> DATE</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >CUSIP</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >QTY</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >PRICE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >PRINCIPAL <br> AMOUNT</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >INTEREST</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >COMMCON <br> AMOUNT</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                               >REF <br> NO</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >ACCOUNT <br> TYPE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >EXEC <br> BROKER <br>MINOR</th>  
                          <th 
                              scope="col" 
                              class="sort text-center border-right"
                              >FBSI <br>SHORT <br>NAME</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >SETTLED</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              >Trader</th>                                         
                      </tr>
                      </thead>
                      <tbody class="list no-cursor">
                      <tr v-if="tradeDataCopy.length == 0">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="data in tradeDataCopy" :key="data.id" v-bind:class="{'row-highlight-red' : data.highlight}">
                          <td class="text-center">{{data.accountNo}}</td>
                          <td class="text-center">{{data.actionSb}}</td>
                          <td class="text-center">{{moment(data.tradeDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{moment(data.settlementDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{data.cusip}}</td>
                          <td class="text-center">{{data.quantity}}</td>
                          <td class="text-center">{{data.price | currency}}</td>
                          <td class="text-center">{{data.principalAmnt | currency}}</td>
                          <td class="text-center">{{data.interest | currency}}</td>
                          <td class="text-center">{{data.commConcAmount | currency}}</td>
                          <td class="text-center">{{data.referenceNo}}</td>
                          <td class="text-center">{{data.acctType}}</td>
                          <td class="text-center">{{data.execBrokerMinor}}</td>
                          <td class="text-center border-right">{{data.fbsiShortName}}</td>
                          <td class="text-center">{{data.settled}}</td>
                          <td class="text-center">{{data.firstName}}</td>
                      </tr>
                      </tbody>
                  </table>
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-2 ">
                            <label for="inputEmail4">Account*</label>
                            <input  type="text" class="form-control" id="inputEmail4" placeholder="Account" v-model="tradeData.accountNo"  >
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Trade Date *</label>
                            <datepicker v-model="tradeData.tradeDate"  name="fromDate" placeholder="mm/dd/yyyy" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Settlement Date *</label>
                            <datepicker v-model="tradeData.settlementDate"  name="fromDate" placeholder="mm/dd/yyyy" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Action</label>
                            <select v-model="tradeData.actionSb" class="form-control">
                                <option value="Buy">Buy</option>
                                <option value="Sell">Sell</option>
                            </select>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">CUSIP *</label>
                            <input maxlength="9" type="text" class="form-control" id="inputEmail4" placeholder="CUSIP" v-model="tradeData.cusip"  >
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Quantity *</label>
                            <input  type="number" class="form-control" id="inputEmail4" placeholder="Quantity" v-model="tradeData.quantity"  >
                            <div style="font-size: 12px;font-weight: 600;padding: 9px;" class="text-warning">Quantity format should be as it appears in the file.</div>

                        </div>
                        <div class="form-group col-md-6">
                            <label for="inputEmail4">Security Description *</label>
                            <input  type="text" class="form-control" id="inputEmail4" placeholder="Security Description" v-model="tradeData.cusipDec"  >
                        </div>
                        
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Price *</label>
                            <input  type="number" class="form-control" id="inputEmail4" placeholder="Price" v-model="tradeData.price"  >
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Principal Amount *</label>
                            <input  type="number" class="form-control" id="inputEmail4" placeholder="Principal Amount" v-model="tradeData.principalAmnt"  >
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Interest *</label>
                            <input  type="number" class="form-control" id="inputEmail4" placeholder="Interest" v-model="tradeData.interest"  >
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">COMM/CONC Amount *</label> 
                            <input type="number" class="form-control" id="inputLast" placeholder="COMM/CONC Amount" v-model="tradeData.commConcAmount " >
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Reference* </label> 
                            <input type="text" class="form-control" id="inputLast" placeholder="Reference" v-model="tradeData.referenceNo">
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Primary Acct Holder *</label> 
                            <input type="text" class="form-control" id="inputLast" placeholder="Primary Acct Holder" v-model="tradeData.primaryAcctHolder">
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEmail4">Account Type</label>
                            <select v-model="tradeData.acctType" class="form-control">
                                <option value="Cash">Cash</option>
                                <option value="Margin">Margin</option>
                            </select>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Clearing Broker Minor *</label> 
                            <input type="text" class="form-control" id="inputLast" placeholder="Clearing Broker Minor" v-model="tradeData.clearingBrokerMinor">
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Exec Broker Minor  </label>
                            <input type="text" class="form-control" id="inputLast" placeholder="Exec Broker Minor" v-model="tradeData.execBrokerMinor "> 
                        </div> 
                        <div class="form-group col-md-2">
                            <label for="inputLast">FBSI Short Name *</label>
                            <input type="text" class="form-control" id="inputLast" placeholder="FBSI Short Name" v-model="tradeData.fbsiShortName "> 
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Exchange Code </label>
                            <input type="text" class="form-control" id="inputLast" placeholder="Exchange Code" v-model="tradeData.exchangeCode "> 
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Security Type *</label>
                            <!-- <input type="text" class="form-control" id="inputLast" placeholder="Security Type" v-model="tradeData.securityType ">  -->
                            <select v-model="tradeData.securityType" class="form-control">
                                <option value="Fixed Income">Fixed Income</option>
                                <option value="Equities">Equities</option>
                                <option value="Cash & Cash Equivalents">Cash & Cash Equivalents</option>
                                <option value="Units">Units</option>
                                <option value="Mutual Funds">Mutual Funds</option>
                                <option value="Rights & Warrants">Rights & Warrants</option>
                            </select>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">RR1 *</label>
                            <input type="text" class="form-control" id="inputLast" placeholder="RR1" v-model="tradeData.repCode "> 
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputLast">Exec Time *</label>
                            <input type="time" step="2" class="form-control" id="inputLast" v-model="tradeData.tradeTime "> 
                        </div>
                    </div>
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <p v-if="errors.length">
                        <ul>
                        <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </p>
                    <div class="modal-footer bid">
                        <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                        <button :disabled="disableEdit" type="button" class="btn btn-primary" @click="addTrade(true)">ADD TRADE</button>
                    </div>
              </form>
            </div>
          </div>
        </div>
        <DuplicateTrade 
          v-if="duplicateTradeModalOpen"
          v-bind:tradeData="duplicateTradeData"
          @close="toggleDuplicateTradeModal()"
          @continue="addTrade(false)"
        />
</div>
</template>
<script>
    import authService from "@/authService";
    import config from "@/config";
    import Datepicker from 'vuejs-datepicker';
    import DuplicateTrade from './DuplicateTradeModal'
    export default {
        name: 'pltraderadd',
        components :{
            Datepicker,
            DuplicateTrade
        },
        props: ['tradeDataCopy'],
        data() {
            return {
                duplicateTradeData : null,
                duplicateTradeModalOpen : false,
                loading : false,
                errors: [],
                tradeData : {
                        "accountNo": "",
                        "tradeDate": "",
                        "settlementDate": "",
                        "actionSb" : "Sell",
                        "cusip" : "",
                        "cusipDec" : "",
                        "quantity" : "",
                        "price" : "",
                        "principalAmnt" : "",
                        "interest" : "",
                        "commConcAmount" : "",
                        "referenceNo" : "",
                        "primaryAcctHolder" : "",
                        "acctType" : "Margin",
                        "clearingBrokerMinor" : "",
                        "execBrokerMinor" : "",
                        "fbsiShortName" : "",
                        "exchangeCode" : "",
                        "securityType" : "Fixed Income",
                        "repCode" : "",
                        "tradeTime" : ""
                    },
                disableEdit : false           

            };
        },
        methods: {   
            toggleDuplicateTradeModal(){
                this.duplicateTradeModalOpen = !this.duplicateTradeModalOpen;
            },
            addTrade(dryRun){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.tradeData.settlementDate = this.moment(this.tradeData.settlementDate).format("MM/DD/YYYY");
                    this.tradeData.tradeDate = this.moment(this.tradeData.tradeDate).format("MM/DD/YYYY");
                    this.tradeData.isDryRun = dryRun;
                    this.cognitoSub = authService.getUser().cognitoSub
                    this.$http
                    .post(config.baseUrlBidSide + "/pnl/add-trade", this.tradeData, auth)
                    .then((result) => {
                        this.loading = false; 
                        if(result.data.msg == 'DUPLICATE_REF_FOUND'){
                            this.duplicateTradeData = result.data.tradeToBeCancelled;
                            this.toggleDuplicateTradeModal();   
                        }
                        if(result.data.msg == 'TRADE_ADDED'){
                            this.$alert("Trade added successfully","","success");  
                            this.$emit('close');               

                        }
                        if(result.data.msg == 'TRADE_CANCELLED'){
                            this.$alert("Trade cancelled successfully","","success");    
                            this.$emit('close');               

                        }
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            checkForm(){
                this.errors = [];
                if (!this.tradeData.accountNo) {
                    this.errors.push("Account no is required.");
                    return false;
                }
                if (!this.tradeData.tradeDate) {
                    this.errors.push("Trade Date is required.");
                    return false;
                }
                if (!this.tradeData.settlementDate) {
                    this.errors.push("Settlement Date is required.");
                    return false;
                }
                if (!this.tradeData.cusip) {
                    this.errors.push("Cusip is required.");
                    return false;
                }
                if (!this.tradeData.cusipDec) {
                    this.errors.push("Cusip description is required.");
                    return false;
                }
                if (!this.tradeData.quantity) {
                    this.errors.push("Quantity is required.");
                    return false;
                }
                if (!this.tradeData.price) {
                    this.errors.push("Price is required.");
                    return false;
                }
                if (!this.tradeData.principalAmnt) {
                    this.errors.push("Principal Amount is required.");
                    return false;
                }
                if (!this.tradeData.interest) {
                    this.errors.push("Interest is required.");
                    return false;
                }
                if (!this.tradeData.commConcAmount) {
                    this.errors.push("CommConc Amount is required.");
                    return false;
                }
                if (!this.tradeData.referenceNo) {
                    this.errors.push("ReferenceNo is required.");
                    return false;
                }
                if (!this.tradeData.primaryAcctHolder) {
                    this.errors.push("Primary Acct Holder is required.");
                    return false;
                }
                if (!this.tradeData.clearingBrokerMinor) {
                    this.errors.push("Clearing Broker Minor is required.");
                    return false;
                }
                // if (!this.tradeData.execBrokerMinor) {
                //     this.errors.push("Exec Broker Minor is required.");
                //     return false;
                // }
                if (!this.tradeData.fbsiShortName) {
                    this.errors.push("fbsi Short Name is required.");
                    return false;
                }
                // if (!this.tradeData.exchangeCode) {
                //     this.errors.push("Exchange Code is required.");
                //     return false;
                // }
                if (!this.tradeData.securityType) {
                    this.errors.push("Security Type is required.");
                    return false;
                }
                if (!this.tradeData.repCode) {
                    this.errors.push("RepCode is required.");
                    return false;
                }
                if (!this.tradeData.tradeTime) {
                    this.errors.push("Trade Time is required.");
                    return false;
                }
                return true

            }

            

        },
        mounted() {
            console.log(this.tradeDataCopy)
            if(this.tradeDataCopy[0]){
                let tradeCopy =  {...this.tradeDataCopy[0]}
                for (const key in this.tradeData) {
                    this.tradeData[key] = tradeCopy[key]
                }
                this.tradeData.cusipDec = tradeCopy.cusipDesc;
                this.tradeData.referenceNo = ""
            }
            this.getPLRemapStatus().then((result) => {
                if(result.data.remapOngoing){
                    this.$alert(this.appMessages.plRemapMessage,"","warning");  
                    this.disableEdit = true;            
                }else{
                    this.disableEdit = false;              
                }
            })
        }
    };
    </script>
